import { render, staticRenderFns } from "./psd_form.vue?vue&type=template&id=20ed6301&scoped=true&"
import script from "./psd_form.vue?vue&type=script&lang=ts&"
export * from "./psd_form.vue?vue&type=script&lang=ts&"
import style0 from "./psd_form.vue?vue&type=style&index=0&id=20ed6301&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ed6301",
  null
  
)

export default component.exports